import { Editor } from '@tiptap/core';
import { Redo2Icon, Undo2Icon } from 'lucide-react';
import React from 'react';

import { Button } from '@/ui/Button';
import { cn } from '@/utils';

interface HistoryMenuItemProps {
	editor: Editor | null;
}

const HistoryMenuItem = (props: HistoryMenuItemProps) => {
	const { editor } = props;

	if (!editor) {
		return null;
	}

	return (
		<div className="flex gap-2 items-center">
			<Button
				onClick={() => editor.chain().focus().undo().run()}
				className={cn('w-6 h-6 text-brand-gray-2 [&>svg]:reset p-0 [&>svg]:left-[0px]')}
				disabled={!editor.can().chain().focus().undo().run()}
				size="icon"
				icon="left"
				variant="tetriary"
			>
				<Undo2Icon />
			</Button>

			<Button
				onClick={() => editor.chain().focus().redo().run()}
				className={cn('w-6 h-6 text-brand-gray-2 [&>svg]:reset p-0 [&>svg]:left-[0px]')}
				disabled={!editor.can().chain().focus().redo().run()}
				size="icon"
				icon="left"
				variant="tetriary"
			>
				<Redo2Icon />
			</Button>
		</div>
	);
};

export { HistoryMenuItem };
